export const promoteDashboard = (promoteArr: any, promoteString: string) => {
    for (let i = 0; i < promoteArr.length; i++) {
      if (promoteArr[i].productId === promoteString) {
        let a = promoteArr.splice(i, 1);
        promoteArr.unshift(a[0]);
        break;
      }
    }
    return promoteArr;
  };
  export   function moveReachLast(licensesList:any ,targetProductName:string) {
    // Separate the target product from the rest
    let targetProduct = null;
    let otherProducts = licensesList.filter((product: any) => {
        if (product.productName === targetProductName) {
            targetProduct = product;
            return false;
        }
        return true;
    });

    // If target product is found, add it to the end of the other products array
    if (targetProduct) {
        otherProducts.push(targetProduct);
    }

    return otherProducts;
}